import { API, METHODS } from '../constants';
import { fetchData } from '../utils';

export const getMarketplaceLabelGoods = async ({ data = {} }) => {
  const url = API.MARKETPLACE_LABELS_GOODS;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};

export const printMarketplaceLabels = async ({ data = {} }) => {
  const url = API.MARKETPLACE_LABELS_PRINT;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};
